import React from "react";
import PageTemplate from "../components/PageTemplate";
import UTMsHeaderMobile from "../components/targeting/UTMsHeaderMobile";
import UTMsBody from '../components/targeting/UTMsBody';

const UTMs = () => {
  return (
    <PageTemplate
      title="UTM Parameters"
      mobileHeader={<UTMsHeaderMobile/>}
      sidebarTitle="UTM Parameters"
      sidebarSubtitle="Display this to visitors segmented by UTMs."
      centered
      fullWidth
    >
      <UTMsBody/>
    </PageTemplate>
  );
};

export default UTMs;
